import React, { useState, useEffect } from 'react'

const CategoriasPos = ({ funcion, categorias, onClick, categoriasFull }) => {

	//busca la categoria en el array principal de categorias

	const imprimeNombre = (categoriaId) => {
		let resultado = ''
		categoriasFull.map(item => {
			if (item.id === categoriaId)
				resultado = item.nombre
		})
		if (categoriaId === 'todo' || categoriaId === 'Todo' || categoriaId === 'TODO') { resultado = 'Todo' }
		return resultado
	}

	return (
		<div className=" contCategorias animate__animated animate__bounce animate__slow">
			{funcion === 'cargando' ?
				<div className="loader">Loading...</div>
				: null}
			{funcion == 'ver' ?
				categorias.map((categoria, index) => {
					if (imprimeNombre(categoria) !== "") {
						return (
							<div className="col-lg-3 col-md-4 col-6 CatPos" key={index}>
								<button
									value={categoria}
									name={categoria}
									onClick={onClick(categoria)}
									className="btnCate btn btn-block">
									{imprimeNombre(categoria)}
								</button>
							</div>
						)
					}
				})
				: null}
		</div>
	)
}



export default CategoriasPos